const creativeTypes = ['standard', 'video', 'mraid', 'custom_html', 'native', 'third_party_vast'];

const creativeSettings = ['allow_create', 'auto_approve'];

export { creativeTypes, creativeSettings };
